/**
 * The job/customer fields a WhatsApp template variable can be mapped to. The
 * config tab shows these as the options per template placeholder; the (future)
 * message composer resolves the chosen key from the job + linked customer when
 * it queues a message. Keep the keys stable — they're persisted in the template
 * config's `variables` map.
 */
export interface WhatsAppTemplateField {
  key: string
  label: string
}

export const whatsappTemplateFields: WhatsAppTemplateField[] = [
  { key: 'customer_first_name', label: 'Customer first name' },
  { key: 'customer_full_name', label: 'Customer full name' },
  { key: 'customer_phone', label: 'Customer phone' },
  { key: 'job_public_id', label: 'Public ID' },
  { key: 'job_number_tag', label: 'Job tag' },
  { key: 'device_type', label: 'Device type' },
  { key: 'job_fault', label: 'Reported fault' },
]

export function whatsappTemplateFieldLabel(key: string): string {
  return whatsappTemplateFields.find((field) => field.key === key)?.label ?? key
}
